import { basicAxios } from "../../sevices/baseAxios";

export const getApplicationDocument = async (data) => {
  const response = await basicAxios.get(
    `/api/Document/GetApplicationDocuments?id=${data.id}&pageSize=${data.pageSize}&pageIndex=${data.pageIndex}`,
  );
  return response.data;
};

export const getRepositoryDocument = async (data) => {
  const response = await basicAxios.get(
    `/api/Document/GetRespositoryDocuments?id=${data.id}&pageSize=${data.pageSize}&pageIndex=${data.pageIndex}`,
  );
  return response.data;
};

export const deleteDocfolder = async (id) => {
  const response = await basicAxios.delete(
    `/api/Document/DeleteFolderById?id=${id.id}`,
  );
  return response.data;
};

export const deleteDocfile = async (id) => {
  const response = await basicAxios.delete(
    `/api/Document/DeleteDocumentById?id=${id.id}`,
  );
  return response.data;
};

export const addNewFolder = async (data) => {
  const response = await basicAxios.post("/api/Document/AddFolder", data);
  return response.data;
};

export const getRepositoryFilteredDocument = async (data) => {
  const response = await basicAxios.post(
    "/api/Document/FilterRepositoryDocuments",
    data,
  );
  return response.data;
};

export const getDocumentFilteredDocument = async (data) => {
  const response = await basicAxios.post(
    "/api/Document/FilterApplicationDocuments",
    data,
  );
  return response.data;
};

export const addDocument = async (data) => {
  const response = await basicAxios.post("/api/Document/AddDocumentUrl", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const downloadOfDocument = async (id) => {
  const response = await basicAxios.get(
    `/api/Document/DownloadFileUrl?id=${id}`,
  );
  return response.data;
};
